export enum TenantResource {
    FiscalizationMonitoring = "Fiscalization/Monitoring",
    AdminSingleCompanyTenant = "AdminSingleCompanyTenant",
    TravelWarrant = "TravelWarrant",
    TravelWarrantItem = "TravelWarrantItem",
    Contact = "Contact",
    Company = "Company",
    CompanyRunbookNote = "CompanyRunbookNote",
    ContactCompany = "ContactCompany",
    ContactEmail = "ContactEmail",
    SupportTicketCRUD = "SupportTicketCRUD",
    PersonalVehicle = "PersonalVehicle",
    WebShopTenantArticle = "WebShopArticleTenant",
    FeaturedCategory = "WebShopFeaturedCategoryTenant",
    Projects = "Projects",
    SupportToDo = "SupportTodo",
    Subjects = "Subjects",
    MarservisWorkOrders = "MarservisWorkOrders",
    MarservisWorkOrderItem = "MarservisWorkOrderItem",
    MarservisWorkOrderItemWork = "MarservisWorkOrderItemWork",
    MarservisMaterial = "MarservisMaterial",
    MarservisItemGroupMaterials = "MarservisItemGroupMaterials",
    MarservisUserWorkOrderItem = "MarservisUserWorkOrderItem",
    DocumentType = "DocumentType",
    AdminDocumentTypes = "AdminDocumentTypes",
    AdminPantheonUsers = "AdminPantheonUsers",
    Item = "Item",
    CompanyDocuments = "CompanyDocuments",
    AccountMoney = "Account+Money",
    AccountCustomer = "Account+Customer",
    AccountSupplier = "Account+Supplier",
    SupportUsers = "SupportUsers",
    SupportGroups = "SupportGroups",
    SupportCannedResponses = "SupportCannedResponses",
    SpamEmails = "SpamEmails",
    AdminUsersTenant = "AdminUsersTenant",
    AdminCompaniesTenant = "AdminCompaniesTenant",
    ApplicationPackets = "ApplicationPackets",
    SQLTemplates = "SQLTemplates",
    SqlMetadataTables = "SqlMetadata/Tables",
    SqlMetadataViews = "SqlMetadata/Views",
    SqlMetadataProcedures = "SqlMetadata/Procedures",
    SqlMetadataFunctions = "SqlMetadata/Functions",
    SqlMetadataTriggers = "SqlMetadata/Triggers",
    SqlMetadataSynonyms = "SqlMetadata/Synonyms",
    SqlMetadataSequences = "SqlMetadata/Sequences",
    SqlMetadataTypes = "SqlMetadata/Types",
    SqlMetadataSchemas = "SqlMetadata/Schemas",
    SqlMetadataRoles = "SqlMetadata/Roles",
    SqlMetadataUsers = "SqlMetadata/Users",
    SqlMetadataSessions = "SqlMetadata/Sessions",
    ServerDowntimeTenant = "ServerDowntimeTenant",
    Department = "Department",
    ItemGroup = "ItemGroup",
    WorkRecordCostType = "WorkRecordCostType",
    SupportTicketDetails = "SupportTicketDetails",
    SavedFile = "SavedFile",
    ApplicationUserSavedFiles = "ApplicationUserSavedFiles",
    ItemGroupItems = "ItemGroupItems",
    AdminMobileSettings = "AdminMobileSettings",
    SupportCompanyTeamViewerContact = "SupportCompanyTeamViewerContact",
    CompanyTeamViewerUsers = "CompanyTeamViewerUsers",
    SupportCompanyTeamViewerDevice = "SupportCompanyTeamViewerDevice",
    CompanyMeshCentralGroupMappings = "CompanyMeshCentralGroupMappings",
    TeamViewerSessions = "TeamViewerSessions",
    ApplicationUserWakaMachines = "ApplicationUserWakaMachines",
    ApplicationUserWakaAuthors = "ApplicationUserWakaAuthors",
    ApplicationUserWakaProjectMaps = "ApplicationUserWakaProjectMaps",
    WakaTimeWorklogs = "WakaTimeWorklogs",
    AdminDocumentTypePairs = "AdminDocumentTypePairs",
    Synchronizations = "Synchronizations",
    AdminUserAccounts = "AdminUserAccounts",
    AdminDocumentTransformations = "AdminDocumentTransformations",
    MarservisWorkOrderItemItem = "MarservisWorkOrderItemItem",
    PantheonTHeSetSubj = "PantheonTHeSetSubj",
    PantheonTHeSetSubjWithAcSubjType = "PantheonTHeSetSubjWithAcSubjType",
    CiscoPhoneSessions = "CiscoPhoneSessions",
    ContactPhone = "ContactPhone",
    WebDocumentNewTHeOrder = "WebDocuments/THeOrder",
    WebDocumentTHeOrderList = "WebDocuments/THeOrderList",
    WebDocumentNewTHeMove = "WebDocuments/THeMove",
    WebDocumentTHeMoveList = "WebDocuments/THeMoveList",
    WebDocumentTHeSetSubj = "WebDocuments/THeSetSubj",
    WebDocumentNewTHeOrderItems = "WebDocuments/THeOrderItem",
    WebDocumentTHeSetItem = "WebDocuments/THeSetItem",
    RemoteConnections = "RemoteConnections",
    AdminDocumentTypeLinks = "AdminDocumentTypeLinks",
    WebDocumentNewTHeMoveItems = "WebDocuments/THeMoveItem",
    MobileReleases = "MobileReleases",
    ActiveMobileReleases = "ActiveMobileReleases",
    MobileReleaseSavedFiles = "MobileReleaseSavedFiles",
    ArbitraryDocumentTypeFields = "ArbitraryDocumentTypeFields",
    SynchronizationsTenant = "SynchronizationsTenant",
    AdminCompanyEmailForwards = "AdminCompanyEmailForwards",
    AresTPaSqli = "Ares/TPaSqli",
    AresTPaSqliSearch = "Ares/TPaSqliSearch",
    AresTPaSqliform = "Ares/TPaSqliform",
    AresTPaSqliformName = "Ares/TPaSqliformName",
    AresTPaSqlipcu = "Ares/TPaSqlipcu",
    AresTPaSqlistep = "Ares/TPaSqlistep",
    AresTPaSqlistepFile = "Ares/TPaSqlistepFile",
    AresTPaSqlistepStr = "Ares/TPaSqlistepStr",
    AresTPaSqlitranslation = "Ares/TPaSqlitranslation",
    AresTPaSqlivar = "Ares/TPaSqlivar",
    AresTPaSqliver = "Ares/TPaSqliver",
    PantheonTPaReport = "Pantheon/TPaReport",
    TravelWarrantCostType = "TravelWarrantCostType",
    Currency = "Currency",
    Country = "Country",
    TenantUsers = "TenantUsers",
    ExpenseBearer = "ExpenseBearer",
    ActiveCostTypes = "ActiveCostTypes",
    OfficialVehicle = "OfficialVehicle",
    WorkRecordsOverviewUsers = "WorkRecordsOverviewUsers",
    AllExpenseBearers = "AllExpenseBearers",
    AdminTHeMove = "AdminTHeMove",
    AdminTHeOrder = "AdminTHeOrder",
    LabelDefinitions = "LabelDefinitions",
    LabelDefinitionLocations = "LabelDefinitionLocations",
    LabelComposition = "LabelComposition",
    PantheonInis = "PantheonInis",
    UserOnixDesktopSettings = "UserOnixDesktopSettings",
    PantheonVersions = "PantheonVersions",
    SupportTicketTimeLog = "SupportTicketTimeLog",
    OnixPhoneUserTaskQueue = "OnixPhoneUserTaskQueue",
    OnixClrInstallations = "OnixClrInstallations",
    CompanyMachineUids = "CompanyMachineUids",
    TimeLogTemplate = "TimeLogTemplate",
    EmailTestingRequests = "EmailTestingRequests",
    EmailTestingResults = "EmailTestingResults",
    PantheonTMnSetClassification = "PantheonTMnSetClassification",
    PantheonTMnMailbox = "PantheonTMnMailbox",
    PantheonTMnStorage = "PantheonTMnStorage",
    OpenAISessionCrud = "OpenAISessionCrud",
    OpenAISessionMessageCrud = "OpenAISessionMessageCrud",
    AdminUserArbitrarySettings = "AdminUserArbitrarySettings",
    WikiEntry = "WikiEntry",
    WikiEntryTags = "WikiEntryTags",
    WikiEntryCategories = "WikiEntryCategories",
    WikiEntryCategoryPublic = "WikiEntryCategoryPublic",
    WikiEntryPublic = "WikiEntryPublic",
    WikiEntryTagPublic = "WikiEntryTagPublic",
    IBackupComputer = "IBackupComputer",
    IBackupEventLogEntry = "IBackupEventLogEntry",
    WorkRecordsUsers = "WorkRecordsUsers",
    Fiscalization = "Fiscalization",
    PantheonTMnStatus = "PantheonTMnStatus",
    ClientServers = "ClientServer",
    ClientServerWorkHours = "ClientServerWorkHours",
    CompanySettingsWorkHours = "CompanySettingsWorkHours",
    AresDeploymentGroup = "AresDeploymentGroup",
    AresDeploymentAres = "AresDeploymentAres",
    AresDeploymentGroupSnapshot = "AresDeploymentGroupSnapshot",
    AresDeploymentGroupCompanyMapping = "AresDeploymentGroupCompanyMapping",
    AresDeploymentAresCompanyCurrentVersion = "AresDeploymentAresCompanyCurrentVersion",
    AresDeploymentGroupInstallationStep = "AresDeploymentGroupInstallationStep",
    AresDeploymentWorkflowDefinition = "AresDeploymentWorkflowDefinition",
    AresTPaWorkflowDefinition = "Ares/TPaWorkflowDefinition",
    CompanyAresGroupStep = "CompanyAresGroupStep",
    PreparedSupportTimeLogs = "PreparedSupportTimeLogs"
}
